'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _config = require('../../../redux/modules/config');

var _whiteLabel = require('../../../redux/modules/whiteLabel');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WhiteLabelFooter = require('./WhiteLabelFooter');

var _WhiteLabelFooter2 = _interopRequireDefault(_WhiteLabelFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        baseUrl: (0, _config.getBaseUrl)(state),
        name: (0, _whiteLabel.getWhiteLabelName)(state)
    };
};

var WhiteLabelFooterContainer = function (_PureComponent) {
    (0, _inherits3.default)(WhiteLabelFooterContainer, _PureComponent);

    function WhiteLabelFooterContainer() {
        (0, _classCallCheck3.default)(this, WhiteLabelFooterContainer);
        return (0, _possibleConstructorReturn3.default)(this, (WhiteLabelFooterContainer.__proto__ || (0, _getPrototypeOf2.default)(WhiteLabelFooterContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(WhiteLabelFooterContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                name = _props.name;


            return (0, _jsx3.default)(_WhiteLabelFooter2.default, {
                baseUrl: baseUrl,
                name: name
            });
        }
    }]);
    return WhiteLabelFooterContainer;
}(_react.PureComponent);

exports.default = (0, _reactRedux.connect)(mapStateToProps)(WhiteLabelFooterContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/WhiteLabelFooter/WhiteLabelFooterContainer.js
// module id = d3Wo
// module chunks = 57